import { Injectable, ApplicationRef, Type } from '@angular/core';
import { Modal } from './modal.model';
import { ModalRef } from './modal-ref.model';
import { ModalContainerComponent } from './components/modal-container/modal-container.component';

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    private modalContainer: HTMLElement;

    constructor(
        private appRef: ApplicationRef
    ) {
        this.setupModalContainerDiv()
    }

    open<T extends Modal>(component: Type<T>, inputs?: any): ModalRef {
        this.setupModalContainerDiv();

        const modalContainerRef = this.appRef.bootstrap(ModalContainerComponent, this.modalContainer);

        const modalComponentRef = modalContainerRef.instance.createModal(component);

        if (inputs) {
            modalComponentRef.instance.onInjectInputs(inputs);
        }

        const modalRef = new ModalRef(modalContainerRef, modalComponentRef);

        return modalRef;
    }

    private setupModalContainerDiv(): void {
        this.modalContainer = document.createElement('div');
        document.getElementsByTagName('body')[0].appendChild(this.modalContainer);
    }

}
